import { Card, Grid, Typography } from '@mui/material'

import { numberFormat } from '../../../../../utils'
import { IOrderReportBucket } from '../types'

interface Props {
  summary?: IOrderReportBucket
}

// การ์ดสรุป 4 ใบ — รายละเอียดที่เหลืออยู่ใน SettlementBreakdownTable
const SettlementCards = ({ summary }: Props) => {
  const revenue = Number(summary?.revenueTotal ?? 0)
  const net = Number(summary?.netTotal ?? 0)
  const fee = Number(summary?.feeTotal ?? 0)
  const settled = Number(summary?.settledCount ?? 0)
  const total = Number(summary?.count ?? 0)

  // % เทียบยอดขาย — ยอดขาย ฿0 (ยังไม่มีออเดอร์ที่จ่ายแล้ว) ให้ซ่อน % ไม่ใช่โชว์ NaN
  const pct = (value: number) =>
    revenue ? `${numberFormat((value / revenue) * 100, 1)}%` : '—'

  const items = [
    {
      key: 'revenue',
      label: 'ยอดขาย',
      value: revenue,
      money: true,
      color: '#13c2c2',
      hint: 'ยอดขายก่อนหักค่าธรรมเนียม (เฉพาะที่จ่ายแล้ว)',
    },
    {
      key: 'fee',
      label: 'ค่าธรรมเนียมรวม',
      value: fee,
      money: true,
      color: '#fa541c',
      hint: `${pct(fee)} ของยอดขาย`,
    },
    {
      key: 'net',
      label: 'ยอดที่ได้รับจริง',
      value: net,
      money: true,
      color: '#52c41a',
      hint: `${pct(net)} ของยอดขาย`,
    },
    {
      key: 'settled',
      label: 'ออเดอร์ที่จ่ายแล้ว',
      value: settled,
      money: false,
      color: '#1677ff',
      hint: `จาก ${numberFormat(total, 0)} ออเดอร์ (ที่เหลือรอรอบจ่าย)`,
      suffix: ` / ${numberFormat(total, 0)}`,
    },
  ]

  return (
    <Grid container spacing={2} mb={2} columns={{ xs: 1, sm: 2, lg: 4 }}>
      {items.map((item) => (
        <Grid item xs={1} key={item.key}>
          <Card
            variant="outlined"
            sx={{ p: 2, height: '100%', borderLeft: `4px solid ${item.color}` }}
          >
            <Typography variant="body2" color="text.secondary">
              {item.label}
            </Typography>
            <Typography
              variant="h5"
              sx={{ mt: 1, fontWeight: 600, color: item.color }}
            >
              {item.money && '฿'}
              {numberFormat(item.value, item.money ? 2 : 0)}
              {item.suffix ?? ''}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {item.hint}
            </Typography>
          </Card>
        </Grid>
      ))}
    </Grid>
  )
}

export default SettlementCards
